export function isArray(a: any): a is any[] {
  return Array.isArray(a)
}
